import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { CarParkingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Car_Parking_FAQ = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {CarParkingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="inner-title">
                  <h3 className="fontSizeClass">
                    {t("Dept of Parking :: FAQs")}
                  </h3>
                </div>
                <div id="accordion">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <button
                        className="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        1. {t("What are the key activities of the department")}?
                      </button>
                    </div>
                    <div
                      id="collapseOne"
                      className="collapse show"
                      data-parent="#accordion"
                    >
                      <div class="card-body m-3">
                        The key activities of the department are,
                        <ul className="kmc-function-list">
                          {[
                            "To provide safe car parking facilities to citizens",
                            "Generate revenues for KMC by way of parking fees",
                          ].map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading2">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse2"
                        aria-expanded="true"
                        aria-controls="collapse2"
                      >
                        2.
                        {t(
                          "What are the contact details of the parking department"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse2"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          The contact details of the parking department are, CM
                          Parking, 5, S.N. Banerjee Road, Kolkata 70003, Phone:
                          22861000, Ext-2829
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading3">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse3"
                        aria-expanded="true"
                        aria-controls="collapse3"
                      >
                        3.
                        {t(
                          "What can I do if parking space is not maintained well or lacks basic amenities"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse3"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t(
                            "In the event that basic amenities are unavailable at parking locations please write details of issues to Supervisor Parking, 5, S.N. Banerjee Road, Kolkata 70003 or call Phone: 22861000, Ext 2823"
                          )}
                          .
                          <br />
                        </p>
                        <p className="fontSizeClass"></p>
                        <p className="fontSizeClass">
                          {t(
                            "We would be happy to assist you and resolve issues as soon as possible"
                          )}
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading4">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse4"
                        aria-expanded="true"
                        aria-controls="collapse4"
                      >
                        4.
                        {t(
                          "How will I get feedback from KMC regarding resolution of my complaint"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse4"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t(
                            "At the time KMC receives a parking complaint, they take name, address details, nature of complaint etc. from citizens. KMC believes that it is very important to interact with complainants. Once KMC has resolved parking issues, it ensures that a letter is sent to the address provided"
                          )}
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading5">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse5"
                        aria-expanded="true"
                        aria-controls="collapse5"
                      >
                        5.
                        {t(
                          "How safe are vehicles parked at KMC maintained parking areas"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse5"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t(
                            "KMC designated parking areas have personnel provided by fee car parking societies. These persons are physically present at parking sites throughout parking timings. They personally inspect parking areas and ensure that such areas are safe for vehicles parked. KMC however does not take any guarantee for the safety"
                          )}
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading6">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse6"
                        aria-expanded="true"
                        aria-controls="collapse6"
                      >
                        6.
                        {t(
                          "What should I do if I notice my vehicle has been tampered at fee parking areas"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse6"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t(
                            "In the unlikely event that a vehicle has been tampered in a KMC designated car-parking area, please contact us at the address provided above or call the KMC parking department at 22861000 (Extension - 2829). If your vehicle has been tampered on account of negligence by parking attendant we will take suitable action against the parking society personnel. We suggest that, in addition to the above measure, you may kindly complaint to the local police authorities. You can also contact the fee car parking societies whose details have been provided in the website"
                          )}
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading7">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse7"
                        aria-expanded="true"
                        aria-controls="collapse7"
                      >
                        7.
                        {t(
                          "How can I ensure that a particular collector is authorized by KMC"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse7"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <p className="fontSizeClass">
                          {t(
                            "The parking department provides identity cards to authorized collectors through their fee car parking societies. Please ensure that the person collecting cash from you is wearing this identity card on person. If you have any doubt on a parking collector, please call us at"
                          )}
                          {t("22861000, Extension - 2829")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading8">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse8"
                        aria-expanded="true"
                        aria-controls="collapse8"
                      >
                        8. What precautions should I take regarding parking in
                        public places?
                      </button>
                    </div>
                    <div
                      id="collapse8"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <ul className="kmc-function-list">
                          {[
                            "Please ensure that an authorized parking collector is present at the site.",
                            "Please ensure that you pay parking charges as per the rate board chart that is provided at all locations.",
                            "Please make sure that you park in such a way that other parkers can remove their vehicles easily",
                          ].map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading9">
                      <button
                        class="btn btn-link fontSizeClass "
                        data-toggle="collapse"
                        data-target="#collapse9"
                        aria-expanded="true"
                        aria-controls="collapse9"
                      >
                        9.
                        {t(
                          "What are the common complaints & their corresponding resolution time"
                        )}
                        ?
                      </button>
                    </div>
                    <div
                      id="collapse9"
                      className="collapse "
                      data-parent="#accordion"
                    >
                      <div className="card-body m-3 fontSizeClass">
                        <div class="card-body m-3">
                          The most common complaints are,
                          <ul className="kmc-function-list">
                            {[
                              "Scarcity of parking space",
                              "Excess Parking charges",
                              "Misbehavior by parking attendant",
                            ].map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                          Please contact Supervisor Parking at 22861000 –
                          Extension – 2829 with any of these complaints. Issues
                          related to excess parking charges & misbehavior are
                          resolved within 15 days of complaint. Issues related
                          to scarcity of parking space take longer depending on
                          the parking location.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Car_Parking_FAQ;
